import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const ArrowUpIconSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18 15.6094L12 9.60938L6 15.6094'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ArrowUpIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowUpIconSvg} {...props} />
);
